// overwrote default options
// https://github.com/ckeditor/ckeditor5-highlight/blob/cba07991e1992aa70c3ad9daf0f306cf0ecc3531/src/highlight.js#L88-L193
export const highlightOptions = [
  {
    model: 'yellowMarker',
    class: 'marker-yellow',
    title: 'Yellow marker',
    color: 'var(--ck-highlight-marker-yellow)',
    type: 'marker',
  },
  {
    model: 'greenMarker',
    class: 'marker-green',
    title: 'Green marker',
    color: 'var(--ck-highlight-marker-green)',
    type: 'marker',
  },
  {
    model: 'pinkMarker',
    class: 'marker-pink',
    title: 'Pink marker',
    color: 'var(--ck-highlight-marker-pink)',
    type: 'marker',
  },
  {
    model: 'blueMarker',
    class: 'marker-blue',
    title: 'Blue marker',
    color: 'var(--ck-highlight-marker-blue)',
    type: 'marker',
  },
  {
    model: 'redPen',
    class: 'pen-red',
    title: 'Red pen',
    color: 'var(--ck-highlight-pen-red)',
    type: 'pen',
  },
  {
    model: 'greenPen',
    class: 'pen-green',
    title: 'Green pen',
    color: 'var(--ck-highlight-pen-green)',
    type: 'pen',
  },
];
